export default {
      id: "ic-plan-textiles-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-textiles-usage",
      toString: function () {
        return this.url;
      }
    }